import React from 'react';
import { renderNothing } from 'recompose';

const ImpactedUploadStatus = ({
  changeImpact,
  project,
  onDownloadErrorsCsv,
}) => {
  return changeImpact.groupStructureErrors ? (
    <div className="component-xl component-xl component-bg-white component-border-bottom text-center">
      <h3 className="text-danger">
        There was an issue with the impacted groups and people CSV.
      </h3>
      <br />
      <br />

      {project.manageProjectEntities ? (
        <p className="no-margin">
          Please download the CSV error report
          <button
            type="button"
            className="btn-link"
            onClick={onDownloadErrorsCsv}
          >
            here
          </button>
        </p>
      ) : null}
    </div>
  ) : (
    renderNothing
  );
};

export default ImpactedUploadStatus;
